__turbopack_context__.v({
  "active": "dropdown-module-scss-module__RlDhnq__active",
  "bgLayer": "dropdown-module-scss-module__RlDhnq__bgLayer",
  "blocksBackgroundColor": "dropdown-module-scss-module__RlDhnq__blocksBackgroundColor",
  "blocksFontColor": "dropdown-module-scss-module__RlDhnq__blocksFontColor",
  "content": "dropdown-module-scss-module__RlDhnq__content",
  "dropDownDetails": "dropdown-module-scss-module__RlDhnq__dropDownDetails",
  "dropdown": "dropdown-module-scss-module__RlDhnq__dropdown",
  "dropdownArrow": "dropdown-module-scss-module__RlDhnq__dropdownArrow",
  "dropdownIconLink": "dropdown-module-scss-module__RlDhnq__dropdownIconLink",
  "dropdownList": "dropdown-module-scss-module__RlDhnq__dropdownList",
  "dropdownListAbove": "dropdown-module-scss-module__RlDhnq__dropdownListAbove",
  "gallery": "dropdown-module-scss-module__RlDhnq__gallery",
  "label": "dropdown-module-scss-module__RlDhnq__label",
  "links": "dropdown-module-scss-module__RlDhnq__links",
  "links-list": "dropdown-module-scss-module__RlDhnq__links-list",
  "morphDropdownWrapper": "dropdown-module-scss-module__RlDhnq__morphDropdownWrapper",
  "no-csstransitions": "dropdown-module-scss-module__RlDhnq__no-csstransitions",
  "popOutIcon": "dropdown-module-scss-module__RlDhnq__popOutIcon",
  "secondaryNavBackgroundColor": "dropdown-module-scss-module__RlDhnq__secondaryNavBackgroundColor",
  "themeBackgroundColor": "dropdown-module-scss-module__RlDhnq__themeBackgroundColor",
  "themeFontColor": "dropdown-module-scss-module__RlDhnq__themeFontColor",
});
